import { render, staticRenderFns } from "./CreateNewApplication.vue?vue&type=template&id=5ca4eba4&scoped=true"
import script from "./CreateNewApplication.vue?vue&type=script&lang=js"
export * from "./CreateNewApplication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca4eba4",
  null
  
)

export default component.exports